import _classCallCheck from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/ui/validation_group.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../core/renderer";
import registerComponent from "../core/component_registrator";
import DOMComponent from "../core/dom_component";
import ValidationSummary from "./validation_summary";
import ValidationEngine from "./validation_engine";
import Validator from "./validator";
var VALIDATION_ENGINE_CLASS = "dx-validationgroup";
var VALIDATOR_CLASS = "dx-validator";
var VALIDATION_SUMMARY_CLASS = "dx-validationsummary";

var ValidationGroup =
/*#__PURE__*/
function (_DOMComponent) {
  _inherits(ValidationGroup, _DOMComponent);

  function ValidationGroup() {
    _classCallCheck(this, ValidationGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(ValidationGroup).apply(this, arguments));
  }

  _createClass(ValidationGroup, [{
    key: "_getDefaultOptions",
    value: function _getDefaultOptions() {
      return _get(_getPrototypeOf(ValidationGroup.prototype), "_getDefaultOptions", this).call(this);
    }
  }, {
    key: "_init",
    value: function _init() {
      _get(_getPrototypeOf(ValidationGroup.prototype), "_init", this).call(this);

      ValidationEngine.addGroup(this);
    }
  }, {
    key: "_initMarkup",
    value: function _initMarkup() {
      var $element = this.$element();
      $element.addClass(VALIDATION_ENGINE_CLASS);
      $element.find(".".concat(VALIDATOR_CLASS)).each(function (_, validatorContainer) {
        Validator.getInstance($(validatorContainer))._initGroupRegistration();
      });
      $element.find(".".concat(VALIDATION_SUMMARY_CLASS)).each(function (_, summaryContainer) {
        ValidationSummary.getInstance($(summaryContainer))._initGroupRegistration();
      });

      _get(_getPrototypeOf(ValidationGroup.prototype), "_initMarkup", this).call(this);
    }
  }, {
    key: "validate",
    value: function validate() {
      return ValidationEngine.validateGroup(this);
    }
  }, {
    key: "reset",
    value: function reset() {
      return ValidationEngine.resetGroup(this);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      ValidationEngine.removeGroup(this);
      this.$element().removeClass(VALIDATION_ENGINE_CLASS);

      _get(_getPrototypeOf(ValidationGroup.prototype), "_dispose", this).call(this);
    }
  }, {
    key: "_useTemplates",
    value: function _useTemplates() {
      return false;
    }
  }]);

  return ValidationGroup;
}(DOMComponent);

registerComponent("dxValidationGroup", ValidationGroup);
export default ValidationGroup;